module.exports = __webpack_public_path__ + "static/don13-470a194c2460f84bffc5ba35a5e3a4d1.jpg";